import { atom } from 'recoil';

export const warehouseFilterState = atom({
  key: 'warehouse_filter',
  default: {
    regionOptions: [],
    typeOptions: [
      { label: 'Main', value: 1 }, // TODO: import config from filter file
      { label: 'Mobile Hub', value: 2 },
    ],
    selected: {
      owner_ids: null,
      owner_types: null,
      regions: null,
      q: null,
      page: null,
    },
    sort: { order_by: 'id', is_desc: true },
  },
});

export const userCloneFilterState = atom({
  key: 'user_clone_filter',
  default: {
    selected: {
      owner_ids: null,
      owner_types: null,
      regions: null,
      q: null,
      page: null,
    },
    sort: { order_by: 'id', is_desc: true },
  },
});

export const regionListState = atom({ key: 'region-list-state', default: [] });
